// extracted by mini-css-extract-plugin
module.exports = {"query-box":"query-box-1UjWa","title":"title-3PlE7"};